import { createContext } from 'react';

export const ValidateContext = createContext(null);

// Return user or null
/*export function useValidateState() {
    if (localStorage.getItem('motus_validate') == null) {
        return(false);
    }
    else return localStorage.getItem('motus_validate');
}*/